import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { EntityId, USAStates } from "../../Types";
import ValidationError from "../../ZodError";
const TrustEntity = z.object({
    entityId: EntityId,
    trustFormationDocuments: z.string().url(),
    trustName: z.string(),
    contactInformation: z.object({
        emailAddress: z.string(),
        phoneNumber: z.string(),
    }),
    entityAddress: z.object({
        street: z.string(),
        unit: z.string().nullable(),
        city: z.string(),
        state: z.enum(USAStates),
        postalCode: z.string(),
        country: z.string(),
    }),
});
const Response = TrustEntity.array();
export const url = () => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/entity/v1/client/trusts`
        : `https://middleware.uat.farther.com/entity/v1/client/trusts`;
};
export default async function getTrusts(config) {
    const { data } = await axios.get(url(), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getTrusts] Could not parse";
        errorLog("getTrusts", JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getTrusts.js.map